<div class="container-fluid">
  <form #legalConsentForm="ngForm" name="form">
    <input
      *ngIf="isEditing; else header"
      name="title"
      class="form-control my-2"
      type="text"
      [(ngModel)]="legalConsent.Title"
      [maxlength]="appConst.LEGAL_CONSENT_CONTENT_TITLE_MAX_LENGTH"
      required>
    <ng-template #header>
      <h1 class="mt-2" mat-dialog-title>{{ legalConsent.Title }}</h1>
    </ng-template>
    <mat-icon class="close-icon" svgIcon="close" [mat-dialog-close]="false"></mat-icon>
    <mat-dialog-content>
      <div class="row">
        <div class="row w-100 m-0">
          <div class="col-md-12">
            <textarea
              class="form-control"
              name="content"
              [(ngModel)]="legalConsent.Text"
              [maxlength]="appConst.LEGAL_CONSENT_CONTENT_MAX_LENGTH"
              [disabled]="!isEditing"
              autofocus
              required>
            </textarea>
          </div>
          <div class="col-md-12 characters-counter" *ngIf="isEditing">
            <span
              [matTooltip]="'Maximum characters allowed: ' + appConst.LEGAL_CONSENT_CONTENT_MAX_LENGTH"
              [style.color]="legalConsent.Text.length === appConst.LEGAL_CONSENT_CONTENT_MAX_LENGTH ? '#df2938': ''">
                {{ legalConsent.Text.length }} / {{ appConst.LEGAL_CONSENT_CONTENT_MAX_LENGTH }} characters
            </span>
          </div>
        </div>
      </div>
    </mat-dialog-content>

    <div class="footer pt-3">
      <div class="col-12 d-flex justify-content-end p-0">
        <button mat-raised-button type="button" class="mr-3" [mat-dialog-close]="false">
          Cancel
        </button>
        <button mat-raised-button type="button" class="btn-green" [disabled]="!legalConsentForm.valid && isEditing"
          [mat-dialog-close]="legalConsent">
            {{ isEditing ? 'Save' : 'Accept' }}
        </button>
      </div>
    </div>
  </form>
</div>

